module.exports = __webpack_public_path__ + "static/media/ajax-Loader_es.ab1f85ff.gif";